// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__fC9WB","pageNumber":"Paginator_pageNumber__5kuYd","selectedPage":"Paginator_selectedPage__ce4xG","btn":"Paginator_btn__KtU9u"};